import React from "react"

export default function Icon() {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 20 16"
            xmlSpace="preserve"
        >
            <path
                className="cart-icon"
                d="M19.1,5.9h-2.4l-4.3-5.1c-0.1-0.2-0.3-0.2-0.5-0.3c-0.2,0-0.4,0-0.6,0.2
	c-0.2,0.1-0.2,0.3-0.3,0.5c0,0.2,0,0.4,0.2,0.6l3.4,4H5.4l3.4-4C8.9,1.7,9,1.5,8.9,1.2c0-0.2-0.1-0.4-0.3-0.5
	C8.5,0.5,8.3,0.5,8.1,0.5c-0.2,0-0.4,0.1-0.5,0.3L3.3,5.9H0.9c-0.1,0-0.2,0-0.3,0.1C0.5,6.1,0.5,6.1,0.5,6.3v0.8
	c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1h0.6l0.9,6.7c0.1,0.4,0.2,0.7,0.5,1c0.3,0.3,0.7,0.4,1.1,0.4h12c0.4,0,0.7-0.1,1-0.4
	c0.3-0.3,0.5-0.6,0.6-1l0.9-6.7h0.6c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3V6.3c0-0.1,0-0.2-0.1-0.3
	C19.3,5.9,19.2,5.9,19.1,5.9z M16,13.9H4L3.1,7.5h13.8L16,13.9z M10.8,9.3V12c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2
	c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.3-0.2-0.6V9.3c0-0.2,0.1-0.4,0.2-0.6C9.6,8.6,9.8,8.5,10,8.5c0.2,0,0.4,0.1,0.6,0.2
	C10.7,8.9,10.8,9.1,10.8,9.3z M14.5,9.3V12c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2
	c-0.2-0.2-0.2-0.3-0.2-0.6V9.3c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2C14.4,8.9,14.5,9.1,14.5,9.3z
	 M7.1,9.3V12c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.2-0.6,0.2s-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.3-0.2-0.6V9.3c0-0.2,0.1-0.4,0.2-0.6
	c0.2-0.2,0.3-0.2,0.6-0.2s0.4,0.1,0.6,0.2C7,8.9,7.1,9.1,7.1,9.3z"
            />
        </svg>
    )
}
